export default __webpack_public_path__ + "static/media/graphMenu.f648b44b.png";